<div class="centered">
    <h3 class="awaiting-approval-header">
        Awaiting Account Approval
    </h3>
    <p>
        contact <a href="mailto:office@elkislandlocal28.ca?subject=Pending EasyPD Account">office&#64;elkislandlocal28.ca</a>
        if you need help
    </p>
</div>
